var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSex(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.54 51.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#4d9447;stroke-linecap:round;stroke-width:2px;}.cls-1{stroke-miterlimit:10;}.cls-2{stroke-linejoin:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ativo 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1200",
    "data-name": 1200
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.67,
    cy: 28.58,
    r: 11.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 23.3,
    cy: 17.96,
    r: 11.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 30.07,
    y1: 8.46,
    x2: 37.49,
    y2: 1.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.67,
    y1: 50.75,
    x2: 12.67,
    y2: 40.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.42,
    y1: 45.5,
    x2: 17.92,
    y2: 45.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 31.42,
    y1: 1,
    x2: 37.45,
    y2: 1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 37.54,
    y1: 1.12,
    x2: 37.54,
    y2: 7.15
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSex);
export default __webpack_public_path__ + "static/media/sex.80cd66fdd3079d64e826412931c61438.svg";
export { ForwardRef as ReactComponent };